import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, FormInput, FormSelect } from '../../components';
import { fetchOrganizations, fetchUser, addUser, updateUser } from '../../api';
import { back, replace } from '../../actions/nav-actions';
import { retrieve } from '../../actions/users-actions';
import { notify } from '../../utils';
import countries from 'countries-cities';
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_visible: true,
      organization: undefined,
      position: '',
      user: '',
      organizations: [],
      country: '',
    };
    this.getData = this.getData.bind(this);
    this.onRequest = this.onRequest.bind(this);
  }
  componentDidMount() {
    this.getData();
  }
  getData() {
    fetchOrganizations(this.props.user.token)
      .then((organizations) =>
        this.setState({ organizations }, () => {
          let params = this.props.match.params || {};
          if (params.id) {
            fetchUser(this.props.user.token, params.id).then((user) => {
              this.setState({
                user: user.user.email,
                position: user.position,
                organization: user.organization,
                country: user.country,
              });
            });
          }
        })
      )
      .catch((err) => {
        alert(err.message);
      });
  }
  onRequest(event) {
    if (event) event.preventDefault();
    let params = this.props.match.params || {};
    if (!this.state.organization) {
      notify('Validation Error', 'Missing organization code', 'error');
      return;
    }
    if (!params.id) {
      addUser(this.props.user.token, {
        ...this.state,
      })
        .then((user) => {
          this.props.retrieve(this.props.user.token);
          this.props.replace(`/users`);
        })
        .catch((err) => {
          notify('Error', err.message, 'error');
        });
      return;
    }
    updateUser(this.props.user.token, params.id, {
      ...this.state,
    })
      .then((user) => {
        this.props.retrieve(this.props.user.token);
      })
      .catch((err) => {
        notify('Error', err.message, 'error');
      });
  }
  render() {
    let params = this.props.match.params || {};
    return (
      <Modal
        visible={this.state.modal_visible}
        onClose={() => this.setState({ modal_visible: false }, this.props.back)}
        title={params.id ? 'Update User' : 'New User'}
        action_text={params.id ? 'UPDATE USER' : 'ADD USER'}
        onActionClick={this.onRequest}
      >
        <form onSubmit={this.onRequest}>
          <FormInput
            onChange={(user) => {
              this.setState({ user });
            }}
            required
            value={this.state.user}
            placeholder='User email'
          />
          <FormInput
            onChange={(position) => {
              this.setState({ position });
            }}
            required
            value={this.state.position}
            placeholder='Position informations'
          />
          <FormSelect
            style={{ marginBottom: '1rem' }}
            onChange={(option) => {
              let { organization } = this.state;
              if (option) organization = option.value;
              else organization = undefined;
              this.setState({ organization });
            }}
            placeholder='Organizations'
            searchable
            required
            value={this.state.organization}
            options={this.state.organizations.map((org) => ({ label: `${org.name} - ${org.code}`, value: org.code }))}
          />
          <FormSelect
            onChange={(option) => {
              let { country } = this.state;
              country = option.label;
              this.setState({ country });
            }}
            placeholder='Countries'
            searchable
            required
            value={this.state.country}
            options={countries.getCountries().map((option) => ({ label: option, value: option }))}
          />
        </form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
  back() {
    dispatch(back());
  },
  retrieve(token) {
    dispatch(retrieve(token));
  },
  replace(routeName) {
    dispatch(replace(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);



// WEBPACK FOOTER //
// ./src/routers/Users/Form.js